import React from "react";
import { observer } from "mobx-react";
import { Button, Menu } from "@mantine/core";
import { Cubby } from "../stores/Cubby";
import {
  IconSettings,
  IconTrash,
  IconEdit,
  IconInfoHexagon,
  IconCircleCheck,
  IconAlertOctagon,
  IconBolt,
  IconTools,
  IconMenu,
  IconMenu2,
  IconTool,
  IconLogout,
  IconCancel,
  IconDatabase,
  IconWriting,
  IconBook2,
  IconBrandDiscordFilled,
} from "@tabler/icons-react";
import { MODALS } from "../helpers/constants";

const ActionsMenu = observer(({ cubby }: { cubby: Cubby }) => {
  const handleExitNode = () => {
    window.location.href = "/nodes";
  };

  const handleDocs = () => {
    window.location.href = "/docs";
  };

  const handleDiscord = () => {
    window.open("https://discord.gg/ZrT25cC44s", "_blank");
  };

  return (
    <Menu shadow="md" width={200}>
      <Menu.Target>
        <Button leftSection={<IconTool />} variant="default">
          Tools
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        {cubby.allowOnchainActions && (
          <>
            <Menu.Item
              leftSection={<IconDatabase />}
              onClick={() => {
                cubby.cubbyLife("get_info");
                cubby.setModal(MODALS.NODE_INFO);
              }}
            >
              Node Data
            </Menu.Item>

            <Menu.Item
              leftSection={<IconSettings />}
              onClick={() => cubby.setModal(MODALS.USER_SETTINGS)}
            >
              Settings
            </Menu.Item>
          </>
        )}

        {cubby.isConsideredReadyForBasicLightningApiRequests && (
          <Menu.Item
            leftSection={<IconWriting />}
            onClick={() => cubby.setModal(MODALS.SIGN_MESSAGE)}
          >
            Sign Message
          </Menu.Item>
        )}

        <Menu.Item leftSection={<IconLogout />} onClick={handleExitNode}>
          My Nodes
        </Menu.Item>
        <Menu.Item leftSection={<IconBook2 />} onClick={handleDocs}>
          Documentation
        </Menu.Item>

        <Menu.Item
          leftSection={<IconBrandDiscordFilled />}
          onClick={handleDiscord}
        >
          Discord
        </Menu.Item>
        {cubby.isAdminButEverythingServerProtected && (
          <>
            <Menu.Label>Admin Only</Menu.Label>
            {cubby.runStatus === "wallet_info_available" && (
              <Menu.Item
                leftSection={<IconCircleCheck />}
                onClick={() => cubby.cubbyLife("start_subscriptions")}
              >
                Start subscriptions
              </Menu.Item>
            )}
            {cubby.litRpcIsReady && (
              <Menu.Item
                leftSection={<IconAlertOctagon />}
                onClick={() => cubby.cubbyLife("stop_now")}
              >
                Stop cubby
              </Menu.Item>
            )}
            {cubby.runStatus === "not_yet_initialized" && (
              <Menu.Item
                leftSection={<IconBolt />}
                onClick={() => cubby.cubbyLife("initialize_now")}
              >
                Initialize now
              </Menu.Item>
            )}
          </>
        )}
        <Menu.Divider />
        <Menu.Label>Danger zone</Menu.Label>
        {cubby.shouldShowForceStopButton && (
          <Menu.Item
            color="red"
            leftSection={<IconCancel />}
            onClick={() => cubby.cubbyLife("force_stop_now")}
          >
            Force Stop
          </Menu.Item>
        )}
        <Menu.Item
          onClick={() => cubby.setModal(MODALS.DESTROY_CUBBY)}
          color="red"
          leftSection={<IconTrash />}
        >
          Delete This Node
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
});

export default ActionsMenu;
